import React, { useEffect, useState } from "react";
import "./HoleScore.css";
import { useStateValue } from "./StateProvider";
import { holes } from "./CourseInfoOld";
//import {saveSkins} from "./utilities.js";

function HoleScore({ id }) {
  const [{ hole }] = useStateValue();
  const [{ scores }, dispatch2] = useStateValue();
  const [{ overs }, dispatch3] = useStateValue();
  const [{ netovers }, dispatch4] = useStateValue();
  const [{ players }] = useStateValue();
  const [{ skins }] = useStateValue();
  const [{ sums }, dispatch6] = useStateValue([]);
  const [, setLowFront] = useStateValue();
  const [, setLowBack] = useStateValue();
  const [score, setScore] = useState();
  // const [player, setPlayer] = useState();

  useEffect(() => {
    // verify if score already entered if so show score otherwise leavie blank
    const getEnteredScore = () => {
      const holescore = scores.find((s) => s.id === id && s.hole === hole);
      return !holescore?.strokes ? "" : holescore.strokes;
    };
    setScore(getEnteredScore());
  }, [hole]);

  useEffect(() => {
    //save front and back nine totals if all scores entered
    const saveNineHoleTotals = () => {
      //get front scores
      const frontScores = scores.filter((s) => s.id === id && s.hole <= 9);
      if (frontScores.length === 9) {
        calcFrontBackTotals(frontScores, "front");
      }
      // get back scores
      const backScores = scores.filter((s) => s.id === id && s.hole >= 10);
      if (backScores.length === 9) {
        calcFrontBackTotals(backScores, "back");
      }
    };
    saveNineHoleTotals();
    //saveSkins()
    localStorage.setItem("scores", JSON.stringify(scores));
    localStorage.setItem("overs", JSON.stringify(overs));
    localStorage.setItem("netovers", JSON.stringify(netovers));
  }, [scores]);

  useEffect(() => {
    const saveWin = (winner, frontback) => {
      if (frontback === "front")
        setLowFront({
          type: "SAVELOWFRONT",
          lowfront: winner,
        });
      if (frontback === "back")
        setLowBack({
          type: "SAVELOWBACK",
          lowback: winner,
        });
    };

    const assignWinners = (frontback) => {
      const totals = sums.filter((s) => s.nine === frontback);
      sort(totals);
      //with ties no one wins // declare winner
      if (totals.length > 1) {
        // check that lowest is lower than next
        if (totals[0].total < totals[1].total) {
          saveWin(totals[0].id, frontback);
        } else {
          saveWin("", frontback);
        }
      }
    };
    assignWinners("front");
    assignWinners("back");
    localStorage.setItem("sums", JSON.stringify(sums));
  }, [sums]);

  useEffect(() => {
    localStorage.setItem("skins", JSON.stringify(skins));
  }, [skins]);

  const saveScore = (e) => {
    setScore(e.target.value);

    //check if score blank
    if (e.target.value !== "") {
      dispatch2({
        type: "SAVESCORE",
        score: {
          id: id,
          strokes: parseInt(e.target.value),
          hole: hole,
        },
      });
      // track +/-
      const calcOver = parseInt(e.target.value) - holes[hole].par;
      dispatch3({
        type: "SAVEOVER",
        score: {
          id: id,
          strokes: calcOver,
          hole: hole,
        },
      });
      const calcNetOver =
        parseInt(e.target.value) - holes[hole].par - calcDeduction();
      dispatch4({
        type: "SAVENETOVER",
        score: {
          id: id,
          strokes: calcNetOver,
          hole: hole,
        },
      });
      //enter other functions to run when score entered
      //check and save skins winner
      // saveSkins()
      // console.log("Save Score")
      //check team scores

      //save front and back nine totals if all scores entered done with hooks

      //save front and back nine team totals if all scores entered
    }
  };

  const calcDeduction = () => {
    const player = players.filter((s) => s.id === id);

    var Deduction = 0;
    if (player[0].HC < holes[hole].rating) {
      Deduction = 0;
    }

    if (player[0].HC < holes[hole].rating - 18) {
      Deduction = -1;
    }

    if (player[0].HC >= holes[hole].rating) {
      Deduction = 1;
    }

    if (player[0].HC - 18 >= holes[hole].rating) {
      Deduction = 2;
    }

    if (player[0].HC - 36 >= holes[hole].rating) {
      Deduction = 3;
    }
    if (player[0].HC - 54 >= holes[hole].rating) {
      Deduction = 4;
    }
    return Deduction;
  };

  const calcFrontBackTotals = (scoresarray, frontback) => {
    //make sure scores entered for 9 holes
    const total = getTotal(scoresarray);
    //save to sums
    saveTotals(frontback, total);
  };

  const getTotal = (scoresarray) => {
    const Total = scoresarray?.reduce(
      (totalStrokes, score) => totalStrokes + score.strokes,
      0
    );
    return Total;
  };

  const saveTotals = (frontback, total) => {
    dispatch6({
      type: "SAVESUMS",
      sum: {
        id: id,
        nine: frontback,
        total: total,
      },
    });
  };

  const styleScore = () => {
    const holescore = scores.find((s) => s.id === id && s.hole === hole);
    switch (holescore?.strokes - holes[hole].par) {
      case -2:
        return eaglestyle;
      case -1:
        return birdystyle;
      default:
        return regularstyle;
    }
  };

  const sort = (array) =>
    array.sort((a, b) => {
      return a.total - b.total;
    });

  const regularstyle = {
    color: "black",
    backgroundColor: "white",
  };
  const birdystyle = {
    color: "white",
    backgroundColor: "red",
  };
  const eaglestyle = {
    color: "white",
    backgroundColor: "dodgerblue",
  };

  return (
    <div className="holescore">
      <input
        name="result1"
        onChange={(e) => saveScore(e)}
        type="integer"
        inputMode="numeric"
        pattern="[0-9]*"
        className="holescore__result"
        style={styleScore()}
        value={score} //difficult to edit when value set
      />
    </div>
  );
}

export default HoleScore;
